// Restart Workspaces…'s registration (docs/features/workspace-restart.md): the window `restart` (one per Mac), the
// Mac's ⋯ › Restart Workspaces…, and the wire kind `restart` (get · restart → state; the window listens on the link).
import { registerWindow } from '../../core/windows.js'
import { registerHomeItem } from '../../core/home-items.js'
import { registerWire } from '../../core/wire.js'

registerWindow('restart', { module: () => import('./restart.js'), css: 'windows/restart/restart.css', key: (a, key) => 'restart-' + (key || 'mac'), title: () => 'Restart', place: ['home', 'trailing'] })
registerHomeItem({ id: 'restart', label: 'Restart Workspaces…', symbol: 'lucide:rotate-cw', needs: 'paired', section: 'mac', order: 22 })
registerWire('restart', (link, payload, m) => { if (m?.what === 'state') link.restart = m })
